var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodRequisition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2092 18.9865L24 17.2392L22.2851 15.5661C22.1785 15.4983 21.5436 15.2761 21.1409 15.0462C20.3152 14.5847 18.6906 14.0865 17.8826 14.0588C16.3365 13.9994 15.0129 13.7855 13.9454 14.8269C12.8501 15.8956 12.186 15.7548 10.2975 15.5786C9.3828 15.4831 8.75983 15.7628 8.58586 15.8466C8.16365 16.0867 7.92099 16.5383 8.06275 16.8939C8.1443 17.1365 8.45207 17.2013 9.96097 17.2969C10.9441 17.3686 12.0623 17.7595 12.0623 17.7595C12.0623 17.7595 10.5445 18.684 9.45302 18.5247C8.39113 18.3581 6.90909 17.4261 4.25555 16.2137C2.31595 15.3356 1.28603 15.7976 1.04576 16.1609C0.840886 16.4681 1.28524 16.8292 3.17021 17.8895C5.98925 19.4988 8.84156 20.7965 9.86115 20.94C11.4928 21.1735 13.7691 20.7137 15.6811 19.7717C17.4099 18.9227 18.668 18.6831 20.5861 18.8519L22.2092 18.9865Z",
    fill: "#FFCD85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8916 1L13.3679 7.76099C14.66 10.274 12.7808 13.2307 9.8916 13.2307C7.00238 13.2307 5.12323 10.274 6.41533 7.76099L9.8916 1Z",
    fill: "#D82525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodRequisition);
export default __webpack_public_path__ + "static/media/Blood Requisition.d8169a3925c9186cba61d4fc6feadb58.svg";
export { ForwardRef as ReactComponent };